import { render, staticRenderFns } from "./BindBandsDialog.vue?vue&type=template&id=842c2c7c&scoped=true&lang=pug&"
import script from "./BindBandsDialog.vue?vue&type=script&lang=ts&"
export * from "./BindBandsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BindBandsDialog.vue?vue&type=style&index=0&id=842c2c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842c2c7c",
  null
  
)

export default component.exports